import JWPlayer from './JWPlayer';
import { getPlayerConfig } from './PlayerServices';
import { getParam, getReleaseId } from './utils';

class CriticalVideoLoader {
    constructor() {
        this.playerTagSelector = '.deltaPlayer[data-video-id], .deltaPlayer[data-psu]';
        this.incrnum = 0;
        if (!window.fngPlayers) window.fngPlayers = [];
        this.segmentAnalytics = window.SegmentAnalytics;
        this.loadVideos = this.loadVideos.bind(this);
        this.loadScript = this.loadScript.bind(this);
        this.loadEmbedPlayer = this.loadEmbedPlayer.bind(this);
        this.loadPageVideos = this.loadPageVideos.bind(this);
    }

    isVideoDataAutoplay(data) {
        return data && data.autoplay;
    }

    /**
     * Load videos on the page when mark up exists
     */
    loadPageVideos() {
        if (document.querySelector(this.playerTagSelector) !== null) {
            this.loadScript().then((Player) => { 
                this.loadVideos(Player, null, true);
            });
        }
    }

    getVideoElementData(elem) {
        var elemdata = {},
            idnum = ++this.incrnum;
        let randNum = Math.floor(Math.random().toFixed(2) * 100);
        if (elem instanceof Element) {
            const id = + idnum + randNum.toString();
            const videoId = elem.getAttribute('data-video-id');
            const psu = elem.getAttribute('data-psu');
            const location = elem.getAttribute('data-post-location');
            const autoplay = elem.getAttribute('data-autoplay');
            if (!videoId || !elem.id) {
                elem.id = 'Video' + id;
                elemdata.elemId = elem.id;
                elemdata.vid = videoId;
                elemdata.postLocation = location;
                elemdata.psu = psu;
                if (autoplay) {
                    elemdata.autoplay = autoplay === 'true';
                }
            }
            elem.parentElement.id = "video-container-" + id;
            elemdata.container = elem.parentElement.id;
        }
        return elemdata;
    }

    /**
     * assigns a random id to the div element where the video is being played on
     * @param {*} elem 
     */
    getRandomVideoId(elem) {
        let idnum = ++this.incrnum;
        let randNum = Math.floor(Math.random().toFixed(2) * 100);

        if (elem instanceof Element) {
            const id = + idnum + randNum.toString();
            if (!elem.id) {
                elem.id = 'Video' + idnum + randNum.toString();
            }
            elem.parentElement.id = "video-container-" + id;
        }
        return elem.id;
    }

    getVideoElementsData() {
        return [].slice.call(document.querySelectorAll(this.playerTagSelector)).map(this.getVideoElementData.bind(this));
    }

    ArrayContainsVideo(arr, elemId) {
        return arr.indexOf(elemId) !== -1;
    }

    /**
     * Loads a video player
     * @param {*} FNGPlayer 
     * @param {*} elem 
     * @param {*} data
     */
    loadPlayer(FNGPlayer, elem, data) {
        if(data) {
            data.elemId = this.getRandomVideoId(elem);
            data.container = elem.parentElement.id;
            if (!window.fngPlayers) window.fngPlayers = [];
            if (!this.ArrayContainsVideo(window.fngPlayers, data.elemId)) {
                if(data.auth || !this.segmentAnalytics){
                    this.initPlayer(FNGPlayer, data);
                } else {
                    if(this.segmentAnalytics) {
                        this.segmentAnalytics.getAuthData().then(res => {
                            data.auth = res;
                            this.initPlayer(FNGPlayer, data);
                        })
                    }
                }
            }
        }
    }

    async loadEmbedPlayer() {
        let urlQuery = location.search;
        let videoId = getParam(urlQuery, "videoid");
        let videoUrl = getParam(urlQuery, "videourl");
        const psu = getParam(urlQuery, "psu");
        if(videoUrl) {
           videoId = getReleaseId(videoUrl);
        }
        if(psu) {
            videoId = psu;
        }
        const res = await getPlayerConfig(videoId);
        const player = window.FNGPlayer;
        if(res && player) {
            const data = res.data || res;
            data.elemId = "player";
            data.embed = true;
            data.enablePlaylist = false;
            this.initPlayer(player, data, false);
        }
    }

    /**
     * loads short form videos on page load using data attribute
     * @param {*} Player
     * @param {*} videoElementsData 
     * @param {*} sendPageView 
     */
    loadVideos(Player, videoElementsData, sendPageView = false) {
        var context = this;
        var videos = videoElementsData || context.getVideoElementsData();
        if (videos.length > 0) {
            videos.map(async (videoData) => {
                if (!context.ArrayContainsVideo(window.fngPlayers, videoData.elemId)) {
                    const req = videoData.psu || videoData.vid;
                    let res = await getPlayerConfig(req);
                    res = res.data || res;
                    const data = { ...res, ...videoData };
                    if(context.segmentAnalytics) {
                        context.segmentAnalytics.getAuthData().then( auth => {
                            data.auth = auth;
                            context.initPlayer(Player, data, sendPageView);
                        })
                    } else {
                        context.initPlayer(Player, data, sendPageView);
                    }
                }
            });
        }
    }

    initPlayer(player, data, sendPageView = false) {
        data.sendPageView = sendPageView;
        let videoPlayer = new JWPlayer(player, data);
        window.fngPlayers.push(videoPlayer);
    }
    /**
     * loads video player script and it's defaulted to dev if fs-prop meta tag is not found
     * Example meta tag: <meta fs-prop="video" script="//player.foxdcg.com/v3/sports"/>
     */
    loadScript() {
        return new Promise((resolve, reject) => {
            if (typeof FNGPlayer === 'function') {
                resolve(FNGPlayer);
            } else {
                // Create a new script and setup the basics.
                let script = document.createElement("script");
                let firstScript = document.getElementsByTagName('script')[0];
    
                script.async = false;
                script.src = (() => {
    
                    let metaEl = document.querySelector('[fs-prop="video"]');
                    let scripturl = metaEl && metaEl.getAttribute("script");
    
                    if (scripturl === null) {
                        scripturl = '//dev.player.fox.com/v3/sports.js';
                    }
    
                    if (window.location.search.indexOf('debugVideoPlayer') > -1) {
                        if (scripturl.indexOf('?') > -1) scripturl = scripturl + '&debug=all';
                        else scripturl = scripturl + '?debug=all';
                    }
    
                    return scripturl;
    
                })(window.location);
                // Handle the case where an optional callback was passed in.
                script.onload = function() {
                    if (typeof FDM_Player === 'function') {
                        resolve(FDM_Player);
                    } else if (typeof FNGPlayer.default === 'function') {
                        resolve(FNGPlayer);
                    } else {
                        throw new Error('Failed to load player script');
                    }
                    // Clear it out to avoid getting called more than once or any memory leaks.
                    script.onload = script.onreadystatechange = undefined;
                }

                script.onerror = () => {
                    reject();
                };
    
                script.onreadystatechange = function() {
                    if ("loaded" === script.readyState || "complete" === script.readyState) {
                        script.onload();
                    }
                };
    
                //Attach the script tag to the page (before the first script) so the magic can happen.
                firstScript.parentNode.insertBefore(script, firstScript);
            }
        });
    }
}

window.criticalVideoLoader = new CriticalVideoLoader();

export default CriticalVideoLoader;